import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { ErrorMessage } from 'formik';
import { useDispatch } from 'react-redux';

import Loading from '../shared/Loading';
import { formStyles } from '../../lib/constants/SiteVariables';
import { getIndustryTypes } from '../../actions/industries';

export default function StickyIndustryTypeAhead({
  id,
  placeholder,
  setFieldValue,
  error,
  touched,
  values,
}) {
  const [selectedOption, setSelectedOption] = useState();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState([]);
  const dispatch = useDispatch();

  const style = {
    control: (base) => ({
      ...base,
      height: '59.5px !important',
      borderColor:
        touched && error ? '#e22d20' : 'rgba(7, 13, 89, 0.2) !important',
      padding: '0.5rem 0 !important',
      borderRadius: '6px',
    }),
    input: (base) => ({
      ...base,
      paddingTop: '0.9rem !important',
      color: '#070d59',
    }),
    singleValue: (base) => ({
      ...base,
      marginTop: '0.9rem',
      color: '#070d59',
    }),
  };

  useEffect(() => {
    setLoading(true);
    dispatch(getIndustryTypes())
      .then((res) =>
        setOptions(
          res.data.map((i) => ({
            id: i.id,
            value: i.attributes.description,
            label: i.attributes.description,
          })),
        ),
      )
      .finally(() => setLoading(false));
  }, []);

  const onChangeSelectedOption = (e) => {
    const selectedOption = e.id;
    setFieldValue('industry', e.id);
    setSelectedOption(selectedOption);
  };

  if (loading) return <Loading className="w-14 h-14" />;

  return (
    <div
      className="sticky-type-ahead relative h-16 w-full"
      role="stickyindustryselect"
    >
      <Select
        id={id}
        name={id}
        value={selectedOption?.id}
        onChange={onChangeSelectedOption}
        options={options}
        placeholder="Begin search by typing..."
        className="async-type-ahead ring-offset-transparent text-xs 3xs:text-base text-navy-blue"
        styles={style}
        isLoading={loading}
        defaultInputValue={
          options?.find((o) => o.id === values?.industry)?.label
        }
      />
      <label
        htmlFor={id}
        className="placeholder uppercase text-light-gray absolute duration-300 -z-1 origin-0 px-3.5 text-sm 3xs:text-base"
      >
        {placeholder}
      </label>
      <ErrorMessage
        name={id}
        component="div"
        className={formStyles.validation}
      />
    </div>
  );
}
